module.exports = __webpack_public_path__ + "img/bucket_tote.ce370291.jpg";